import { IValidationErrorResponse, NewsRssFeedType, ValidationModule, ValidationType } from '@bciti/types';
import { Observable } from 'rxjs';

export abstract class ValidatorService {
    abstract validateRssFromUrl(type: ValidationType, module: ValidationModule, url: string, rssFeedType?: NewsRssFeedType): Observable<IValidationErrorResponse[]>;
}
